import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sdn-range',
  templateUrl: './sdn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class SDNRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
